import axios from "axios"
import { BulkLabelBatch } from "@app/services/types"

export const fetchBulkLabelsByBatchId = async (bulkLabelBatchId: number): Promise<BulkLabelBatch> => {

	return axios
		.get<BulkLabelBatch>(`skunkworks/bulk-label-batches/${bulkLabelBatchId}?include_bulk_labels=true`)
		.then((response) => response.data)
}
